async function cacheImage(src: string, timeout = 5000): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    const img = new Image();
    let isLoaded = false;

    const timer = setTimeout(() => {
      if (!isLoaded) {
        reject(new Error(`Image load timeout: ${src}`));
      }
    }, timeout);

    img.src = src;
    img.onload = () => {
      isLoaded = true;
      clearTimeout(timer);
      resolve();
    };
    img.onerror = () => {
      isLoaded = true;
      clearTimeout(timer);
      reject(new Error(`Failed to load image: ${src}`));
    };
  });
}

async function cacheImages(srcArray: string[]): Promise<void> {
  const promises = srcArray.map((src) =>
    cacheImage(src).catch((error) => {
      // eslint-disable-next-line no-console
      console.warn(error.message); // Игнорировать отдельные ошибки и продолжать
    }),
  );

  await Promise.all(promises);
}

export { cacheImages };
